import { ROTransaction, RWTransaction } from '../../../db'
import { Context, Entity, Id, Order, PaginatedResult, Paging } from '../../../common'
import { CitizenCategory } from '../../citizens'
import { MunicipalEntity } from '../../municipalEntity'
import { SalesPoint } from '../../salesPoints'

export type UsedCardsStatValues = Record<CitizenCategory, number>

export interface UsedCardsStat extends Entity {
  values: UsedCardsStatValues
  dataEntryDate: Date
  salesPointId: Id
}

export interface DBStoredUsedCardsStat extends Entity {
  dataEntryDate: Date
  salesPointId: Id
  values: string
}

export interface AddUsedCardsStat {
  values: UsedCardsStatValues
  dataEntryDate: Date
  salesPointId: Id
}

export interface UpdateUsedCardsStat {
  values: UsedCardsStatValues
  dataEntryDate?: Date
  salesPointId?: Id
}

export interface GroupedUsedCardsStat {
  municipalEntity: MunicipalEntity
  salesPoint: SalesPoint
  values: UsedCardsStatValues
}

export interface UsedCardsStatFilter {
  ids?: Id[]
  dateFrom?: Date
  dateTo?: Date
  salesPointId?: Id
  municipalEntityId?: Id
}

export interface UsedCardsStatOptions {
  filter?: UsedCardsStatFilter
  order?: Order<UsedCardsStatOrderFields> | undefined
  paging?: Paging
}

export enum UsedCardsStatOrderFields {
  CREATED_AT = 'createdAt',
}

export interface UsedCardsStatsService {
  formReport(
    ctx: Context,
    opts?: UsedCardsStatOptions,
  ): Promise<{ groupedBySP: PaginatedResult<GroupedUsedCardsStat>; groupedByME: GroupedUsedCardsStat[] }>
  add(ctx: Context, usedCardsStat: AddUsedCardsStat): Promise<Id>
}

export interface UsedCardsStatsRepository {
  findAll(tx: ROTransaction, opts?: UsedCardsStatOptions): Promise<PaginatedResult<UsedCardsStat>>
  save(tx: RWTransaction, usedCardsStat: DBStoredUsedCardsStat): Promise<void>
}

export function parseUsedCardsStat(ucs: DBStoredUsedCardsStat): UsedCardsStat {
  return {
    ...ucs,
    values: JSON.parse(ucs.values),
  }
}

export function stringifyUsedCardsStat(ucs: UsedCardsStat): DBStoredUsedCardsStat {
  return {
    ...ucs,
    values: JSON.stringify(ucs.values),
  }
}
